<div class="alert alert-info mb-0">
  <fa-icon icon="info-circle"></fa-icon>
  Information manquante, merci de remplir les champs ci-dessous
</div>
